import React from 'react';
import { TEMPERATURE_LABELS, type Temperature } from '../../../services/revenueTypes';
import { TEMPERATURE_HINT } from '../../../utils/revenueFormat';
import './revenue.css';

interface Props {
  temperature?: Temperature | null;
  evidence?: string | null;
  /** ai | user | registrar */
  source?: string | null;
  compact?: boolean;
}

/** Selo da temperatura da oportunidade (rótulo interno). O título mostra a evidência e quem definiu. */
const TemperatureChip: React.FC<Props> = ({ temperature, evidence, source, compact }) => {
  if (!temperature) return null;
  const who = source === 'user' ? 'corrigida por uma pessoa' : source === 'registrar' ? 'corrigida pelo Registrar' : 'lida pela IA';
  const title = [`${TEMPERATURE_LABELS[temperature]} (${who}): ${TEMPERATURE_HINT[temperature]}`, evidence ? `“${evidence}”` : null]
    .filter(Boolean)
    .join('\n');
  return (
    <span className={`rev-temp rev-temp--${temperature}${compact ? ' rev-temp--compact' : ''}`} title={title} data-testid="temperature-chip">
      <span className="rev-temp__dot" aria-hidden />
      {TEMPERATURE_LABELS[temperature]}
    </span>
  );
};

export default TemperatureChip;
